var _style, _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g3, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _ellipse, _ellipse2, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g4, _g5, _g6, _g7, _path73, _path74, _path75, _path76, _path77, _path78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishResult6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 663.8 350",
    style: {
      enableBackground: "new 0 0 663.8 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.3;fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#2A34F1;}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:#081666;}\n\t.st6{fill:#0C1883;}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:url(#SVGID_9_);}\n\t.st12{fill:url(#SVGID_10_);}\n\t.st13{fill:#00D8FF;}\n\t.st14{opacity:0.2;fill:url(#SVGID_11_);}\n\t.st15{fill:#BC3D00;}\n\t.st16{fill:url(#SVGID_12_);}\n\t.st17{fill:url(#SVGID_13_);}\n\t.st18{fill:url(#SVGID_14_);}\n\t.st19{fill:url(#SVGID_15_);}\n\t.st20{fill:#B90000;}\n\t.st21{fill:url(#SVGID_16_);}\n\t.st22{fill:url(#SVGID_17_);}\n\t.st23{fill:url(#SVGID_18_);}\n\t.st24{fill:url(#SVGID_19_);}\n\t.st25{fill:#FBF400;}\n\t.st26{fill:url(#SVGID_20_);}\n\t.st27{fill:url(#SVGID_21_);}\n\t.st28{fill:url(#SVGID_22_);}\n\t.st29{fill:url(#SVGID_23_);}\n\t.st30{fill:#FFFFFF;}\n\t.st31{fill:url(#SVGID_24_);}\n\t.st32{opacity:0.3;fill:url(#SVGID_25_);}\n\t.st33{fill:url(#SVGID_26_);}\n\t.st34{fill:url(#SVGID_27_);}\n\t.st35{fill:url(#SVGID_28_);}\n\t.st36{fill:url(#SVGID_29_);}\n\t.st37{fill:url(#SVGID_30_);}\n\t.st38{opacity:0.3;fill:url(#SVGID_31_);}\n\t.st39{fill:url(#SVGID_32_);}\n\t.st40{fill:url(#SVGID_33_);}\n\t.st41{fill:url(#SVGID_34_);}\n\t.st42{fill:url(#SVGID_35_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.2534,
    y1: 48.04,
    x2: 337.3141,
    y2: 256.7146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.44,208.11c-0.05,0.11-0.11,0.22-0.16,0.33c-0.12,0.2-0.26,0.39-0.42,0.56c-0.56,0.58-1.39,0.87-2.6,0.57 c-4.36-1.09-10.9-4.8-10.9-4.8s-0.01,0-0.03,0.04c-0.03,0.05-0.07,0.19,0.05,0.45c0.04,0.1,0.11,0.2,0.19,0.33 c0.11,0.19,0.29,0.42,0.54,0.69c0.1,0.12,0.22,0.24,0.34,0.37c0.27,0.26,0.58,0.56,0.97,0.91h0.01c0.1,0.08,0.2,0.18,0.31,0.27 c3.06,2.61,6.1,9.16,4.58,12.21c-1.52,3.06-6.1,3.71-9.38,2.19c-3.28-1.54-8.73-5.23-11.99-3.28c-1.07,0.65-4.28,2.15-8.65,3.93 c-2.01,0.83-4.28,1.7-6.7,2.58c-8.2,2.99-18.19,6-26.31,6.8c-7.6,0.73-11.72,6.02-21.13,9.86c-9.23,3.79-23.57,6.19-51.3,1.52 c-0.56-0.08-1.13-0.19-1.7-0.29c-1.85-0.33-3.75-0.68-5.71-1.06c0,0-4.36-1.54-3.71,1.09c0.67,2.61,21.39,51.04-10.69,77.43 c-32.06,26.39-68.7,17.66-76.11,11.12c-7.42-6.54-15.27-4.36-20.07-6.1c-2.43-0.88-12.89-5.23-22.77-12.05 c-9.67-6.66-18.78-15.68-19.32-26.13c-1.1-21.15,6.1-18.75,2.39-25.07c-3.71-6.34-6.54-9.38-12.86-7.86 c-4.98,1.2-9.01,0.52-11.35-0.79c-0.64-0.35-1.14-0.75-1.52-1.17c-1.74-1.97-15.51,5.11-21.63,14.17 c-3.56,5.28-57.07,40.17-86.33,38.45c-25.71-1.51-51.43,14.49-53.57-12.47c-0.12-1.47-0.16-3.06-0.14-4.8 c0.05-2.54-3.18-3.63-4.66-1.58c-1.82,2.54-4.01,5.59-6.42,8.92c-0.95,1.31-1.93,2.66-2.94,4.05c-4.6,6.31-9.67,13.23-14.29,19.4 c-7.61,10.18-14.03,18.35-15.06,18.48c-2.38,0.26-8.43,1.18-12.14,2.76c-0.61,0.26-1.16,0.53-1.6,0.82 c-0.63,0.41-1.93,1.02-3.66,1.75c-7.08,2.99-21.3,7.8-25.38,7.25c-5.07-0.69-3-2.54-4.84-4.38c-1.85-1.85-4.84,3.45-6.23,3.45 c-1.39,0-5.76-4.84-7.84-5.53c-2.07-0.69-9.22,0.23-14.29-4.76c-4.36-4.31-9.6-14.42-13.31-17.73c-0.6-0.54-1.16-0.91-1.67-1.03 c-3.05-0.76-13.16-5.75-16.84-13.17c-0.8-1.58-1.29-3.26-1.37-5.03c-0.46-10.16-15.68-20.99-14.75-28.82 c0.92-7.84-11.83-20.52-7.64-24.89c4.2-4.39,0.72-13.38,0.03-15.92c-0.44-1.58,4.45-7.12,8.17-11.07c0.65-0.69,1.25-1.43,1.78-2.2 c1.36-1.92,2.34-4.07,2.95-6.35c1.09-4.04,3.86-10.99,10.85-21.41c8.44-12.59,22.28-21.21,30.03-25.34 c3.49-1.86,7.46-2.58,11.39-2.12c0.42,0.05,0.88,0.11,1.35,0.16c11.96,1.37,35.4,4.01,40,4.01c6.21,0,33.19-4.84,48.18-1.96 c1.36,0.26,2.64,0.42,3.83,0.49c1.47,0.1,2.83,0.05,4.08-0.08c2.43-0.24,4.49-0.86,6.19-1.62c1.71-0.76,3.07-1.69,4.11-2.54 c3.33-2.76,6.74-5.4,10.43-7.65c1.44-0.87,2.87-1.74,4.28-2.6l6.88-4.09l1.1-0.65c4.07-2.39,8.08-4.7,12.05-6.95 c26.1-14.71,49.92-26.13,71.27-34.99h0.04c10.31-4.28,20.04-7.95,29.18-11.11c0.01-0.01,0.01-0.01,0.01-0.01 c17.32-5.98,32.49-10.13,45.4-12.98c33.62-7.45,51.72-6.19,51.72-6.19s67.04,7.78,102.03,19.09c0.01,0,0.01,0,0.03,0 c4.98,1.62,9.3,3.29,12.7,5.03c2.43,1.25,4.65,2.38,6.68,3.41v0.01c6.09,3.11,10.46,5.32,13.79,6.97 c7.95,3.96,9.98,4.69,15.62,6.82c0.76,0.29,1.69,0.58,2.72,0.91c2.52,0.77,5.68,1.62,8.69,2.38c4.65,1.16,8.93,2.12,9.88,2.34 l29.28,34.41l23.97,0.26c3.81,2.95,7.03,5.72,9.33,8.13c13.96,14.6,15.27,24.42,15.7,30.3c0.04,0.61,0.16,1.2,0.34,1.74 c0.88,2.88,3.25,4.98,5,6.2C663.56,204.05,664.3,206.26,663.44,208.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.9878,
    y1: 0.3506,
    x2: 413.0678,
    y2: 183.3065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M663.44,208.11c-0.05,0.11-0.11,0.22-0.16,0.33c-0.12,0.2-0.26,0.39-0.42,0.56c-0.56,0.58-1.39,0.87-2.6,0.57 c-4.36-1.09-10.9-4.8-10.9-4.8s-0.01,0-0.03,0.04c-0.01,0.04-0.04,0.12-0.01,0.27c0.03,0.12,0.11,0.29,0.26,0.5 c0.11,0.19,0.29,0.42,0.54,0.69c0.1,0.11,0.22,0.24,0.34,0.37c0.27,0.26,0.58,0.56,0.97,0.91c-36.93-8.89-61.75-20-93.58-29.53 c-9.88-2.96-20.43-5.76-32.22-8.31c-1.54-0.33-3.09-0.65-4.66-0.98c-0.11-0.03-0.23-0.04-0.34-0.07 c-11.12-2.26-23.33-4.27-37.1-5.97c-1.47-0.18-2.96-0.35-4.49-0.53c-1.71-0.2-3.45-0.39-5.22-0.58c-4.15-0.45-8.43-0.86-12.86-1.25 c-2.34-0.2-4.73-0.39-7.16-0.58c-19.67-1.51-42.12-2.46-68.14-2.66c-30.7-0.24-60.95,4.02-89.89,11.18 c-35.43,8.74-68.92,21.78-98.87,36.12c-1.73,0.83-3.44,1.66-5.14,2.49c-8.8-14.3-23.83-30.59-24.05-30.82 c-3.68-3.85-4.16-9.15-4.2-9.78c0.73-0.08,1.44-0.19,2.11-0.33c1.54-0.31,2.9-0.77,4.08-1.31c1.71-0.76,3.07-1.69,4.11-2.54 c3.33-2.76,6.74-5.4,10.43-7.65c1.44-0.87,2.87-1.74,4.28-2.6l6.88-4.09l1.1-0.65c0.92-0.54,1.86-1.09,2.79-1.63 c1.84-1.07,3.66-2.12,5.47-3.15h0.01c1.28-0.73,2.52-1.45,3.78-2.16c26.1-14.71,49.92-26.13,71.27-34.99h0.04 c1.71-0.71,3.41-1.41,5.1-2.09h0.01c4.58-1.85,9.03-3.56,13.36-5.18c3.64-1.36,7.22-2.64,10.7-3.83c0.01-0.01,0.01-0.01,0.01-0.01 c17.32-5.98,32.49-10.13,45.4-12.98c2.43-0.54,4.77-1.03,7.04-1.48c3.51-0.69,6.82-1.29,9.92-1.81c1.09-0.18,2.15-0.35,3.18-0.5 c1.6-0.24,3.14-0.48,4.62-0.67c5.91-0.8,10.89-1.25,14.89-1.51c0.46-0.03,0.91-0.05,1.35-0.08c0.92-0.05,1.79-0.1,2.6-0.12 c5.37-0.2,8.12-0.01,8.12-0.01s1.17,0.14,3.28,0.39c9.07,1.13,35.5,4.57,61.21,9.57c7.03,1.36,14,2.84,20.56,4.42 c1.11,0.27,2.22,0.54,3.3,0.82c4.91,1.24,9.53,2.54,13.69,3.89c0.01,0,0.01,0,0.03,0c0.57,0.19,1.14,0.38,1.7,0.57 c4.27,1.44,7.99,2.92,11,4.46c2.43,1.25,4.65,2.38,6.68,3.41v0.01c0.73,0.37,1.45,0.73,2.13,1.09c0.68,0.34,1.32,0.67,1.94,0.99 c1.66,0.84,3.17,1.6,4.54,2.3c1.97,0.99,3.67,1.85,5.17,2.6c7.95,3.96,9.98,4.69,15.62,6.82c0.76,0.29,1.69,0.58,2.72,0.91 c2.52,0.77,5.68,1.62,8.69,2.38c4.65,1.16,8.93,2.12,9.88,2.34l29.28,34.41l23.97,0.26c3.81,2.95,7.03,5.72,9.33,8.13 c13.96,14.6,15.27,24.42,15.7,30.3c0.04,0.61,0.16,1.2,0.34,1.74c0.18,0.57,0.41,1.11,0.68,1.62c0.82,1.5,1.98,2.72,3.1,3.64 c0.42,0.35,0.83,0.67,1.22,0.94C663.56,204.05,664.3,206.26,663.44,208.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.9106,
    y1: 89.6001,
    x2: 438.0894,
    y2: -5.5955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBF400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1733,
    style: {
      stopColor: "#FBE003"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#FABC08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M511.41,95.05c-1.03-0.37-2.12-0.73-3.22-1.09c-0.01,0-0.01,0-0.03,0c-4.24-1.37-8.96-2.69-13.96-3.94 c-7.42-1.88-15.49-3.6-23.62-5.18c-4.85-0.95-9.72-1.84-14.49-2.66h-0.01c-5.26-0.91-10.43-1.75-15.28-2.52c-0.01,0-0.01,0-0.03,0 c-3.82-0.58-7.46-1.13-10.85-1.62h-0.04c-0.57-0.01-1.07-0.1-1.51-0.22c-0.01-0.01-0.04-0.01-0.05-0.01 c-3.77-0.54-7.19-1.02-10.17-1.41c-0.46-1.48-0.71-2.68-0.6-3.39c1.21-7.93,10.85-5.26,14.47-11.43 c6.92-11.76,22.01-12.18,24.46-18.15c1.47-3.56-11.13-21.85-21.89-38.26c-1.11-1.7-0.54-4.12,1.33-4.92c0.01,0,0.03-0.01,0.05-0.03 c1.28-0.53,2.76-0.08,3.68,0.95C457.9,21.58,491.2,60.6,511.41,95.05z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M475.98,70.99c-3.39,4.47-11.73,8.51-19.89,11.19h-0.01c-5.26-0.91-10.43-1.75-15.28-2.52 c0.23-0.01,0.48-0.03,0.73-0.04c3.1-0.12,9.52-4.02,5.41-4.46c-6.81-0.71-7.04,0.86-12.67,2.27c-1.74,0.44-3.18,0.64-4.35,0.61 h-0.04c-0.57-0.01-1.07-0.1-1.51-0.22c-0.01-0.01-0.04-0.01-0.05-0.01c-1.48-0.46-2.16-1.59-2.12-3.4 c0.07-3.44,10.48-7.94,21.06-8.24c4.13-0.12,5.94-7.04,8.13-8.57c2.19-1.54,2.22,5.98,1.07,8.8c-1.14,2.86,2.52,3.52,7.06-1.79 c4.54-5.32-3.49-7.99-4.7-10.74c-2.81-6.35,6.39-7.37,7.18-1.07c0.35,2.79,3.06,6.44,4.72,6.65c2.5,0.31,0.94-2.65,2.98-1.84 c0.9,0.37,2.01,2.03,2.9,3.96l0.01,0.01C477.72,64.01,477.86,68.51,475.98,70.99z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "476.6,61.57 476.6,61.58 476.58,61.57  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M494.2,90.02c-7.42-1.88-15.49-3.6-23.62-5.18c1.29-0.63,2.69-1.43,4.23-2.45c4.73-3.14,4.64-4.81,8.48-3.94 c9.33,2.11,0.71-11.65-1.48-15.4c-2.11-3.62-35.14-47.01-37.17-50.37c2.38,3.3,41.32,47.2,50.79,67.77 C496.61,82.99,496.15,86.8,494.2,90.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.0648,
    y1: 77.6142,
    x2: 429.138,
    y2: 77.9955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M429.88,78.04c-0.57-0.01-1.07-0.1-1.51-0.22C428.86,77.88,429.36,77.96,429.88,78.04z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M506.71,160.87c-15.83,5.1-31.56,13.17-35.72,22.27c-5.95-3.62-15.19-6.42-29.62-4.58 c-4.11,0.52-11.67,2.88-15.93,8.31c-1.25,1.59-2.22,3.44-2.73,5.59c-17.47-2.27-32.51-1.89-42.32,8.03 c-21.63,21.86-51.38,13-28.4-6.57c22.99-19.56-11.49-16.93,0-29.53c1.92-2.11,3.39-4.16,4.49-6.2c5.52-10.18,1.97-20.07,0.45-34.6 c-0.27-2.62,0.19-5.71,1.26-9.05c0.52,0.23,1.09,0.41,1.7,0.5c0.99,0.16,2.03,0.24,3.25,0.24c0.71,0,1.41-0.03,2.15-0.05 c0.68-0.03,1.35-0.05,2.05-0.05c3.73,0,8.43,0.68,16.83,8.91c12.74,12.47,31.56,16.99,42.01,16.99c6.55,0,10.5-1.51,12.02-4.64 c0.5-1.02,1.4-3.74-1.07-6.95c-3.11-4-7.9-7.8-12.73-11.54c-5.07-3.94-10.85-9.39-11.12-12.4c-0.54-5.87-5.42-13.24-11.27-21.56 c-1.43-2.03-3.19-4.53-3.55-5.33c-0.52-1.85-0.45-3.41-0.44-3.77c5.37-0.2,8.12-0.01,8.12-0.01s1.17,0.14,3.28,0.39l0.72,1.97 c0.41,1.13,10.13,27.69,19.4,36.97c3.63,3.63,7.83,6.08,11.2,8.03c1.86,1.09,4.35,2.54,5.1,3.4c-0.07,0.14-0.19,0.33-0.38,0.57 c-6.65,8.84-2.81,24.05,8.33,33.54c2.43,0.19,4.83,0.38,7.16,0.58l0.08-3.13c0.1-3.45,1.22-9.99,4.79-9.99 c0.79,0,1.74,0.23,2.81,0.69c3.66,1.58,6.92,2.38,9.71,2.38c4.32,0,6.81-1.89,8.14-3.48c0.3-0.35,0.58-0.73,0.82-1.14 c0,0,0,0,0-0.01c0.16-0.24,0.3-0.49,0.44-0.75C493.49,149.84,500.33,155.49,506.71,160.87z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M567.79,189.31c-0.95,0.88-2.09,1.73-3.45,2.52c-3.02,1.77-7,7.44-8.16,13.51c-0.9,4.7-12.47,14.17-26.8,19.01 c-11.23-0.99-18.53-4.33-21.76-9.18c0.23-2.47-0.83-4.53-3.56-6.17c-8.18-4.94-13.95-5.63-23.82-17.42 c-1.56-1.88-4.27-5.44-9.24-8.44c4.16-9.1,19.89-17.17,35.72-22.27c1.05,0.88,2.08,1.75,3.09,2.61c0.16,0.07,0.33,0.15,0.49,0.23 c0.31-0.05,0.68-0.12,1.11-0.18c1.18-0.35,2.38-0.65,3.58-0.91c2-0.46,4.01-0.79,6.05-1.09c4.87-0.72,9.61-1.2,14.51-0.65 c1.48,0.18,2.91,0.46,4.28,0.83c5.68,0.3,11.04,1.56,15.4,6.19c2.13,2.26,3.81,4.98,5.03,7.91c1.69,1.03,3.24,2.5,4.53,4.65 C566.39,183.12,567.37,186.17,567.79,189.31z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M284.93,103.07l-1.28,3.52c-7.65,20.5-22.28,37.16-40.13,45.68c-3.07,1.47-6.49,2.22-10.13,2.22 c-13.8,0-26.92-10.73-27.46-11.19l-1.18-0.98c1.28-0.73,2.52-1.45,3.78-2.16c26.1-14.71,49.92-26.13,71.27-34.99h0.04 C281.54,104.46,283.24,103.75,284.93,103.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.2234,
    y1: 140.6303,
    x2: 283.4915,
    y2: 37.3468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    style: {
      stopColor: "#D8BC49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7769,
    style: {
      stopColor: "#EA9D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M380.6,60.93c-0.37-0.2-0.73-0.39-1.1-0.6c-7.86-4.3-16.61-9.07-24.88-13.57c-1.07-0.58-2.13-1.16-3.18-1.73 c-5.6-3.05-10.89-5.93-15.47-8.42c-1.81-0.98-3.51-1.9-5.07-2.75c0,0,0,0-0.01,0c-0.34,0.03-5.55,0.52-6.63,3.62 c-1.13,3.19-11.6-2.62-15.23-1.81c-3.63,0.82-13.73,4.51-15.46,5.49c-1.71,0.99-6.65-7.87-11.33-2.22 c-4.68,5.67-11.57,13.79-18.46,12.07c-6.89-1.73-18.22,12.06-25.61,11.57c-7.38-0.49-10.33-0.24-12.55,6.16 c-2.22,6.4-11.34,8.62-14.29,8.86s-8.13,16.74-10.1,19.46c-1.96,2.71-10.09,0.24-10.09,3.93c0,3.7,2.95,9.12,0,13.05 c-2.95,3.94-10.59,6.16-10.59,10.35c0,4.19-1.39,17.09,15.93,22.7c4.07-2.39,8.09-4.7,12.06-6.93c0.68,0.56,18.88,15.27,33.23,8.42 c14.6-6.97,29.87-21.47,38.07-43.42c8.54-3.53,16.71-6.68,24.44-9.45c7.97-2.84,15.5-5.32,22.58-7.44 c6.13-1.84,11.94-3.44,17.4-4.81c4.64-1.17,9.03-2.19,13.17-3.07c8.14-1.73,15.34-2.94,21.51-3.77h0.01 c0.57-0.08,1.13-0.16,1.69-0.23h0.01c16.7-2.13,25.48-1.52,25.48-1.52S394.91,68.75,380.6,60.93z M279.42,105.33 c-0.14,0.05-0.27,0.11-0.39,0.15c0.23-0.1,0.49-0.2,0.76-0.31h0.03C279.68,105.22,279.56,105.28,279.42,105.33z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M351,48.09c-0.82,1.82-2.53,3-4.7,3.25c-0.88,0.1-1.16,0.22-1.21,0.24c0,0.07-0.42,0.91-0.42,3.87 c0,7.46-5.36,19.03-12,22.2c-0.8,0.38-1.86,0.8-3.19,1.35c-6.32,2.56-18.69,7.55-25.19,16.71c-7.86,2.81-15.76,5.85-24.44,9.45 l0.01-0.08c0.55-3.66,1.84-7.2,4-10.2c3.06-4.25,7.18-7.26,10.72-9.85c2.53-1.85,5.38-3.93,5.89-5.33 c1.48-4.23,4.89-6.16,7.64-7.72c3.14-1.78,4.81-2.87,5.37-5.91c0.65-3.49,3.19-5.94,5.42-8.1c1.01-0.95,2.66-2.57,2.79-3.22 c0.19-3.7,0.71-13.58,8.29-13.58c0.6,0,1.2,0.07,1.81,0.22c0.88-0.26,2.99-2.62,4.19-4.76c4.58,2.49,9.87,5.37,15.47,8.42 C351.54,46.04,351.45,47.09,351,48.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M378.04,75.15l0.9,1.48c-6.17,0.83-13.36,2.04-21.51,3.77c-0.56-1.48-1.88-2.69-3.14-3.86 c-1.71-1.56-3.86-3.52-3.37-6.55c0.35-2.12,1.88-3.43,3.13-4.19c-1.02-0.91-2.15-2.03-3.05-3.4c-2.13-3.28-2.53-6.74-1.09-9.5 c1.01-1.93,2.8-3.24,4.94-3.7l-0.23-2.43c8.27,4.5,17.02,9.27,24.88,13.57c0.19,0.69,0.31,1.44,0.34,2.23 c0.12,2.81-0.94,5.49-3.07,7.74C376.34,70.73,376.95,73.35,378.04,75.15z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.1552,
    y1: 88.126,
    x2: 330.8784,
    y2: 88.126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C1883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4845,
    style: {
      stopColor: "#1E29C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M330.88,33.87c-0.34,0.03-5.55,0.52-6.63,3.62c-1.13,3.19-11.6-2.62-15.23-1.81 c-3.63,0.82-13.73,4.51-15.46,5.49c-1.71,0.99-6.65-7.87-11.33-2.22c-4.68,5.67-11.57,13.79-18.46,12.07 c-6.89-1.73-18.22,12.06-25.61,11.57c-7.38-0.49-10.33-0.24-12.55,6.16c-2.22,6.4-11.34,8.62-14.29,8.86s-8.13,16.74-10.1,19.46 c-1.96,2.71-10.09,0.24-10.09,3.93c0,3.7,2.95,9.12,0,13.05c-2.95,3.94-10.59,6.16-10.59,10.35c0,4.19-1.39,17.09,15.93,22.7 l-3.02,1.79l-4.96,2.95c-5.44-0.94-15.27-4.8-14.81-9.3c0.48-4.5,0.48-5.44-3.73-9.78c-4.19-4.35-0.01-11.2,1.7-13.81 c1.16-1.78,10.26-16.63,15.76-31.61c5.49-14.97,22.98-27.46,29.96-29.95c6.99-2.5,34.67-17.48,43.17-23.97 c8.48-6.5,30.24-9.49,38.72-8.99c8.5,0.49,16.48,1.5,21.48,4c0.72,0.35,3.02,1.59,6.42,3.43 C328.28,32.47,329.53,33.14,330.88,33.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.6726,
    y1: 86.3045,
    x2: 314.2378,
    y2: 86.3045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0C1883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4845,
    style: {
      stopColor: "#1E29C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M229.67,128.68c2.28-3.38,0.52-5.27,1.22-9.01c0.7-3.74,6.31-3.51,6.08-6.08c-0.23-2.57,5.14-7.25,10.75-8.43 c5.61-1.18,6.31-7.47,7.98-12.5c1.66-5.03,3.71-6.19,9.79-7.82c6.08-1.64,3.97-6.78,5.84-10.29c1.87-3.51,10.75-4.91,12.62-10.29 s3.04-6.31,11.22-6.31c8.18,0,3.74-1.64,2.57-7.95s7.25-6.08,7.25-6.08s12.05,3.28,8.63,6.71s-7.58,1.47-7.34,7.09 s-3.91,7.83-7.83,7.09c-3.91-0.73-2.69,3.42-7.83,9.29c-5.14,5.87-14.67,13.2-14.67,16.38c0,3.18-3.18,9.05-8.31,10.27 s-9.45,7.27-9.25,13.78L229.67,128.68z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M246.13,67.53c-1.51,0.27-2.11,1.27-3.09,2.29c-1.84,0.92-3.15-0.01-4.59,0.64 c-2.96,1.33-0.25,5.39,2.37,4.57c1.21-0.37,1.85-1.06,3.21-1.18c2.29-0.2,3.57-0.94,4.34-1.65 C250.64,70.09,251.05,66.64,246.13,67.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.37,95.28c-1.04,0.87-1.06,1.89-1.37,3.1c-1.01,1.51-2.42,1.36-3.24,2.49c-1.69,2.31,2.15,4.24,3.81,2.47 c0.76-0.81,0.96-1.62,1.95-2.3c1.66-1.15,2.33-2.27,2.6-3.15C236.94,95.28,235.75,92.45,232.37,95.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.42,130.12c-1.4-0.11-2.17,0.63-3.27,1.3c-1.85,0.38-2.78-0.76-4.22-0.52c-2.93,0.48-1.5,4.71,1.02,4.61 c1.16-0.04,1.89-0.5,3.12-0.28c2.07,0.36,3.38,0.02,4.23-0.44C213.81,133.45,214.99,130.49,210.42,130.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M262.47,62.89c-1.13-0.7-2.61-0.53-3.7,0.16c-0.52,0.33-0.98,0.76-1.28,1.31c-1.26,2.26-2.97,2.3-3.06,3.59 c-0.07,1,0.81,1.86,1.81,1.81c0.73-0.03,1.38-0.58,2.07-0.78c0.92-0.27,1.9-0.28,2.82-0.59C263.51,67.6,265.12,64.52,262.47,62.89 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.81,119.02c-1.13-0.7-2.61-0.53-3.7,0.16c-0.52,0.33-0.98,0.76-1.28,1.31c-1.26,2.26-2.97,2.3-3.06,3.59 c-0.07,1,0.81,1.86,1.81,1.81c0.73-0.03,1.38-0.58,2.07-0.78c0.92-0.27,1.9-0.28,2.82-0.59 C196.86,123.73,198.47,120.65,195.81,119.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.23,98.19c-0.63-1.57-2.27-2.52-3.92-2.64c-0.79-0.05-1.58,0.04-2.3,0.37c-3,1.36-4.78,0.11-5.85,1.36 c-0.83,0.97-0.57,2.52,0.48,3.23c0.77,0.52,1.86,0.46,2.71,0.77c1.15,0.43,2.16,1.15,3.33,1.53 C219.74,103.81,223.72,101.87,222.23,98.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.37,113.78c-0.63-1.57-2.27-2.52-3.92-2.64c-0.79-0.05-1.58,0.04-2.3,0.37c-3,1.36-4.78,0.11-5.85,1.36 c-0.83,0.97-0.57,2.52,0.48,3.23c0.77,0.52,1.86,0.46,2.71,0.77c1.15,0.43,2.16,1.15,3.33,1.53 C221.87,119.4,225.85,117.46,224.37,113.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M251.5,79.23c-1.5-0.92-3.44-0.7-4.88,0.21c-0.69,0.44-1.29,1.01-1.69,1.72c-1.66,2.98-3.91,3.04-4.03,4.73 c-0.09,1.32,1.07,2.45,2.38,2.39c0.96-0.04,1.83-0.76,2.73-1.02c1.22-0.35,2.51-0.37,3.71-0.77 C252.87,85.45,255,81.39,251.5,79.23z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M202.63,103.28c-1.49,0.92-2.17,2.76-2,4.46c0.08,0.81,0.32,1.61,0.78,2.28c1.92,2.82,0.96,4.86,2.42,5.73 c1.14,0.68,2.67,0.14,3.21-1.05c0.39-0.88,0.14-1.97,0.31-2.9c0.23-1.25,0.79-2.41,0.98-3.67 C208.81,104.84,206.13,101.12,202.63,103.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.18,79.95c-1.46-0.19-2.88,0.64-3.67,1.84c-0.38,0.57-0.64,1.22-0.7,1.9c-0.25,2.85-1.95,3.67-1.46,5.01 c0.38,1.04,1.66,1.51,2.65,1.01c0.72-0.36,1.14-1.21,1.74-1.72c0.81-0.69,1.79-1.15,2.58-1.87 C236.37,84.23,236.6,80.39,233.18,79.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.91,57.9c-1.55-0.75-6.95,0.82-6.02,3.94c0.64,2.16,4.34,1.73,5.71,0.81 C276.26,61.54,277.12,58.96,274.91,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.86,84.1c-1.28-0.62-5.75,0.68-4.98,3.26c0.53,1.79,3.59,1.43,4.73,0.67 C222.97,87.11,223.69,84.98,221.86,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M194.46,130.95c-1.28-0.62-5.75,0.68-4.98,3.26c0.53,1.79,3.59,1.43,4.73,0.67 C195.58,133.96,196.29,131.83,194.46,130.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.58,121.33c-1.28-0.62-5.75,0.68-4.98,3.26c0.53,1.79,3.59,1.43,4.73,0.67 C209.69,124.34,210.41,122.21,208.58,121.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M284.49,50.45c-1.28-0.62-5.75,0.68-4.98,3.26c0.53,1.79,3.59,1.43,4.73,0.67 C285.6,53.46,286.32,51.33,284.49,50.45z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.5549,
    y1: 96.8215,
    x2: 340.9608,
    y2: 28.1312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M298.3,97.89c7.06-15.34,27.77-21.62,32.6-23.92s9.69-12.01,9.69-18.52s1.74-7.79,5.26-8.17 c3.52-0.39,0-5.29,0-5.29l-6.3-3.43c0,0-4.4,7.91-8.65,6.79c-4.25-1.12-4.92,5.36-5.15,9.61c-0.22,4.25-7.43,7.32-8.27,11.84 c-1.68,9.04-10.95,7.93-13.18,14.25c-2.23,6.31-16,9.86-19.37,22.01L298.3,97.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.9524,
    y1: 86.3927,
    x2: 364.463,
    y2: 63.5573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M374.56,77.27c0,0-3.93-6.45-0.76-9.79c5.06-5.32-1.25-10.94-1.25-10.94l-13.61-7.42c0,0,0.38,3.91-2.52,3.98 s-4.6,3.07-2,7.06s8.92,5.85,2.72,8.62c-6.2,2.77,2.48,4.39,4.32,10.79L374.56,77.27z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.28,242.82c1.24,1.75,1.7,3.82,1.31,5.89c-0.38,2.05-1.55,3.82-3.29,4.98 c-15.16,10.07-25.59,19.22-25.7,19.32l-0.15,0.14c-4.8,3.81-5.79,12.4-2.73,22.31c-0.95,1.31-1.93,2.66-2.94,4.05 c-5.08-13.66-3.1-24.61,3.13-29.56c0,0,10.58-9.31,26.13-19.66c1.7-1.13,2.11-3.41,0.94-5.07c-0.01-0.01-0.01-0.03-0.03-0.04 c-4.13-5.83,1.45-12.63,1.94-22.58c0.15-3.19-2.27-8.29-5.79-13.91c-7.46-11.91-19.9-26.19-23.36-29.82 c-5.1-5.33-5.33-12.52-5.33-12.52c1.47,0.1,2.83,0.05,4.08-0.07c0.04,0.63,0.52,5.93,4.2,9.78c0.22,0.23,15.25,16.52,24.05,30.82 c3.78,6.15,6.42,11.92,6.23,15.91c-0.22,4.34-1.25,7.98-2.16,11.2C194.43,238.85,194,241.01,195.28,242.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.7083,
    y1: 278.8336,
    x2: 132.4158,
    y2: 232.5852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    style: {
      stopColor: "#D8BC49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7769,
    style: {
      stopColor: "#EA9D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.95,245.17c-4.13-5.83,1.45-12.63,1.94-22.58c0.48-9.97-24.05-38.38-29.15-43.72 c-5.1-5.33-5.33-12.52-5.33-12.52c-1.2-0.07-2.47-0.23-3.83-0.49c-2.6-0.5-5.56-0.76-8.7-0.86c-4.2-0.15-8.74,0.01-13.21,0.33 c-11.52,0.77-22.57,2.49-26.27,2.49c-4.6,0-28.03-2.64-40-4.01c-7.85,4.06-14.46,7.93-17.45,18.1c-0.67,2.28,0.94,4.59,3.31,4.72 l34.02,1.89c0.73,0.04,1.31,0.67,1.26,1.4c-0.04,0.68-0.6,1.22-1.26,1.26l-36.91,2c-2.56,0.14-4.97,1.17-6.88,2.88 c-3.96,3.53-9.14,6.9-11.47,9.65c-1.44,1.71-2.48,3.4-3.16,5.08c-0.85,2.12,0.96,4.35,3.22,4.06l48.1-6.22 c0.72-0.1,1.4,0.42,1.5,1.16c0.08,0.68-0.37,1.31-1.02,1.47l-46.37,11.06c-2.15,0.51-3.02,3.07-1.66,4.82 c0.26,0.34,0.53,0.67,0.81,1.01c1.41,1.7,2.32,3.77,2.85,6.05c0.61,2.63,3.34,4.19,5.96,3.55l37.78-9.16 c0.72-0.18,1.44,0.27,1.62,0.98c0.16,0.68-0.22,1.35-0.86,1.58L39.1,245.83c-1.66,0.58-2.87,2.01-3.22,3.74 c-0.65,3.24-1.51,6.3-2.33,8.86c-0.41,1.27-0.69,2.45-0.87,3.55c-0.29,1.87,1.53,3.37,3.34,2.83l55.9-16.68 c0.71-0.22,1.45,0.19,1.66,0.9c0.2,0.67-0.15,1.37-0.79,1.62l-53.57,21.08c-1.74,0.69-2.23,2.95-0.9,4.26 c2.84,2.81,6.02,5.47,7.82,9.28c1.56,3.3,1.2,6.88,1,10.42c-0.16,2.86,2.93,4.75,5.4,3.29l54.06-32.06 c0.64-0.37,1.45-0.16,1.84,0.48c0.35,0.6,0.18,1.37-0.38,1.77l-52.49,37.25c-1.88,1.34-2.04,4.09-0.3,5.6 c4.03,3.51,9.56,7.23,14.85,7.23c6.94,0,12.47-0.31,17.35,1.34c1.3,0.44,2.73,0.15,3.71-0.81l43.4-42.61 c0.53-0.52,1.37-0.52,1.89,0.01c0.49,0.5,0.5,1.29,0.05,1.81l-37.28,43.13c-1.08,1.25-0.16,3.16,1.49,3.12 c12.13-0.3,35.16-5.54,46.77-6.34c4.62-6.17,9.69-13.09,14.29-19.4c-5.08-13.66-3.1-24.61,3.13-29.56c0,0,10.58-9.31,26.13-19.66 c1.7-1.13,2.11-3.41,0.94-5.07C191.96,245.2,191.96,245.19,191.95,245.17z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M656.55,194.95c0,0-7.86-4.61-15.73-5.14c-3.92-0.26-12.97-2.52-17.23-6.61c-1.26-1.22-3.15-3.74-5.42-5.41 c-2.42-1.79-5.23-2.99-8.21-3.52c-6.01-1.07-16.91-3.24-19.63-5.3c-3.79-2.9-14.07-7.49-16.9-11.86 c-8.49-13.1-12.15-28.56-5.04-37.61c4.65,1.16,8.93,2.12,9.88,2.34l29.28,34.41l23.97,0.26c3.81,2.95,7.03,5.72,9.33,8.13 C654.81,179.25,656.11,189.07,656.55,194.95z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M147.49,318.9c-7.61,10.18-14.03,18.35-15.06,18.48c-2.77,0.3-10.51,1.51-13.75,3.58 c-3.22,2.08-23.97,9.69-29.04,9c-5.07-0.69-3-2.54-4.84-4.38c-1.85-1.85-4.84,3.45-6.23,3.45c-1.39,0-5.76-4.84-7.84-5.53 c-2.07-0.69-9.22,0.23-14.29-4.76c-5.07-5-11.3-17.84-14.98-18.76c-3.7-0.92-17.76-8.06-18.22-18.2 c-0.46-10.16-15.68-20.99-14.75-28.82c0.92-7.84-11.83-20.52-7.64-24.89c4.2-4.39,0.72-13.38,0.03-15.92 c-0.44-1.58,4.45-7.12,8.17-11.07c2.28-2.41,3.87-5.36,4.73-8.55c1.09-4.04,3.86-10.99,10.85-21.41 c8.44-12.58,22.28-21.21,30.02-25.34c3.49-1.86,7.48-2.58,11.41-2.12c0.43,0.05,0.88,0.11,1.35,0.16 c-7.85,4.06-14.46,7.93-17.45,18.1c-0.67,2.27,0.94,4.59,3.31,4.72l34.02,1.89c0.73,0.04,1.31,0.67,1.26,1.4 c-0.04,0.68-0.6,1.22-1.26,1.26l-36.91,2c-2.56,0.14-4.97,1.17-6.88,2.88c-3.96,3.53-9.14,6.9-11.47,9.65 c-1.44,1.71-2.48,3.4-3.16,5.08c-0.85,2.12,0.96,4.35,3.22,4.06l48.1-6.22c0.72-0.1,1.4,0.42,1.5,1.16 c0.08,0.68-0.37,1.31-1.02,1.47l-46.37,11.06c-2.15,0.51-3.02,3.07-1.66,4.82c0.26,0.34,0.53,0.67,0.81,1.01 c1.41,1.7,2.32,3.77,2.85,6.05c0.61,2.63,3.34,4.19,5.96,3.55l37.78-9.16c0.72-0.18,1.44,0.27,1.62,0.98 c0.16,0.68-0.22,1.35-0.86,1.58L39.1,245.83c-1.66,0.58-2.87,2.01-3.22,3.74c-0.65,3.24-1.51,6.3-2.33,8.86 c-0.41,1.27-0.69,2.45-0.87,3.55c-0.29,1.87,1.53,3.37,3.34,2.83l55.9-16.68c0.71-0.22,1.45,0.19,1.66,0.9 c0.2,0.67-0.15,1.37-0.79,1.62l-53.57,21.08c-1.74,0.69-2.23,2.95-0.9,4.26c2.84,2.81,6.02,5.47,7.82,9.28 c1.56,3.3,1.2,6.88,1,10.42c-0.16,2.86,2.93,4.75,5.4,3.29l54.06-32.06c0.64-0.37,1.45-0.16,1.84,0.48 c0.35,0.6,0.18,1.37-0.38,1.77l-52.49,37.25c-1.88,1.34-2.04,4.09-0.3,5.6c4.03,3.51,9.56,7.23,14.85,7.23 c6.94,0,12.47-0.31,17.35,1.34c1.3,0.44,2.73,0.15,3.71-0.81l43.4-42.61c0.53-0.52,1.37-0.52,1.89,0.01 c0.49,0.5,0.5,1.29,0.05,1.81l-37.28,43.13c-1.08,1.25-0.16,3.16,1.49,3.12C112.84,324.95,135.88,319.71,147.49,318.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.6062,
    y1: 284.2537,
    x2: 13.4468,
    y2: 318.7168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#151613"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    style: {
      stopColor: "#0C1883",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#048762",
      stopOpacity: 0
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M147.49,318.9c-7.61,10.18-14.03,18.35-15.06,18.48c-2.77,0.3-10.51,1.51-13.75,3.58 c-3.22,2.08-23.97,9.69-29.04,9c-5.07-0.69-3-2.54-4.84-4.38c-1.85-1.85-4.84,3.45-6.23,3.45c-1.39,0-5.76-4.84-7.84-5.53 c-2.07-0.69-9.22,0.23-14.29-4.76c-5.07-5-11.3-17.84-14.98-18.76c-3.7-0.92-17.76-8.06-18.22-18.2 c-0.46-10.16-15.68-20.99-14.75-28.82c0.92-7.84-11.83-20.52-7.64-24.89c4.2-4.39,0.72-13.38,0.03-15.92 c-0.44-1.58,4.45-7.12,8.17-11.07c2.28-2.41,3.87-5.36,4.73-8.55c1.09-4.04,3.86-10.99,10.85-21.41 c8.44-12.58,22.28-21.21,30.02-25.34c3.49-1.86,7.48-2.58,11.41-2.12c0.43,0.05,0.88,0.11,1.35,0.16 c-7.85,4.06-14.46,7.93-17.45,18.1c-0.67,2.27,0.94,4.59,3.31,4.72l34.02,1.89c0.73,0.04,1.31,0.67,1.26,1.4 c-0.04,0.68-0.6,1.22-1.26,1.26l-36.91,2c-2.56,0.14-4.97,1.17-6.88,2.88c-3.96,3.53-9.14,6.9-11.47,9.65 c-1.44,1.71-2.48,3.4-3.16,5.08c-0.85,2.12,0.96,4.35,3.22,4.06l48.1-6.22c0.72-0.1,1.4,0.42,1.5,1.16 c0.08,0.68-0.37,1.31-1.02,1.47l-46.37,11.06c-2.15,0.51-3.02,3.07-1.66,4.82c0.26,0.34,0.53,0.67,0.81,1.01 c1.41,1.7,2.32,3.77,2.85,6.05c0.61,2.63,3.34,4.19,5.96,3.55l37.78-9.16c0.72-0.18,1.44,0.27,1.62,0.98 c0.16,0.68-0.22,1.35-0.86,1.58L39.1,245.83c-1.66,0.58-2.87,2.01-3.22,3.74c-0.65,3.24-1.51,6.3-2.33,8.86 c-0.41,1.27-0.69,2.45-0.87,3.55c-0.29,1.87,1.53,3.37,3.34,2.83l55.9-16.68c0.71-0.22,1.45,0.19,1.66,0.9 c0.2,0.67-0.15,1.37-0.79,1.62l-53.57,21.08c-1.74,0.69-2.23,2.95-0.9,4.26c2.84,2.81,6.02,5.47,7.82,9.28 c1.56,3.3,1.2,6.88,1,10.42c-0.16,2.86,2.93,4.75,5.4,3.29l54.06-32.06c0.64-0.37,1.45-0.16,1.84,0.48 c0.35,0.6,0.18,1.37-0.38,1.77l-52.49,37.25c-1.88,1.34-2.04,4.09-0.3,5.6c4.03,3.51,9.56,7.23,14.85,7.23 c6.94,0,12.47-0.31,17.35,1.34c1.3,0.44,2.73,0.15,3.71-0.81l43.4-42.61c0.53-0.52,1.37-0.52,1.89,0.01 c0.49,0.5,0.5,1.29,0.05,1.81l-37.28,43.13c-1.08,1.25-0.16,3.16,1.49,3.12C112.84,324.95,135.88,319.71,147.49,318.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M149.03,188.41c-5.3-0.95-45.59-4.16-57.16-4.9c-16.03-1.02-28.91-1.15-29.34-4.52 c-0.54-4.26,20.57-2.81,27.43-2.2c4.77,0.43,16.35,1.76,21.49,2.36c12.17,1.44,26.25,2.84,38.21,7.15 C152.9,187.48,151.68,188.89,149.03,188.41z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M145.07,200c-5.38,0.06-53.72,1.74-65.23,3.18c-15.94,2-28.61,4.29-29.66,1.05 c-1.33-4.08,19.68-6.62,26.53-7.3c4.76-0.47,16.39-1.34,21.55-1.7c12.23-0.87,34.48,0.59,47.03,2.58 C148.7,198.35,147.77,199.97,145.07,200z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M139.69,213.74c-5.35,0.6-53.27,7.17-64.57,9.78c-15.65,3.6-28.03,7.17-29.4,4.05 c-1.74-3.93,18.91-8.58,25.65-9.95c4.69-0.95,16.17-2.99,21.27-3.88c12.08-2.1,34.36-2.91,47.05-2.2 C143.13,211.73,142.37,213.43,139.69,213.74z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M147.4,226.3c-5.67,1.27-56.41,13.89-68.31,17.97c-16.49,5.65-29.48,10.86-31.13,7.77 c-2.08-3.91,19.67-11.25,26.78-13.5c4.95-1.56,17.07-5.07,22.46-6.61c12.76-3.65,36.49-7.16,50.06-7.93 C150.96,223.79,150.24,225.66,147.4,226.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M158.91,236.13c-6.02,2.38-59.88,24.94-72.53,31.39c-17.52,8.93-31.35,16.75-33.05,13.87 c-2.15-3.64,20.98-15.3,28.53-18.96c5.26-2.54,18.14-8.44,23.86-11.04c13.55-6.16,38.71-14.25,53.08-17.6 C162.71,232.87,161.93,234.93,158.91,236.13z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M168.99,244.05c-5.46,3.48-54.01,35.93-65.19,44.67c-15.49,12.11-27.57,22.44-29.79,19.93 c-2.8-3.16,17.66-19.03,24.38-24.06c4.68-3.5,16.19-11.75,21.31-15.4c12.12-8.64,35.27-21.38,48.74-27.42 C172.09,240.12,171.72,242.3,168.99,244.05z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M175.25,248.97c-2.81,3.65-27.22,37.07-32.33,45.58c-7.08,11.78-12.24,21.52-14.97,20.52 c-3.45-1.26,5.95-16.74,9.11-21.71c2.2-3.45,7.76-11.73,10.24-15.41c5.88-8.69,18.62-22.89,26.59-30.28 C176.06,245.66,176.66,247.14,175.25,248.97z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M499.07,320.81c-32.06,26.39-68.7,17.66-76.11,11.12c-7.42-6.54-15.27-4.36-20.07-6.1 c-2.07-0.75-9.88-3.98-18.23-9.11c5.49-23.21,19.96-39.74,24.95-44.89c6.81-0.24,13.61,2.69,17.77,7.74 c2.53,0.6,4.89,1.52,7.42,2.73c2.19-0.75,4.39-1.5,6.59-2.24c0.35-0.37,0.69-0.73,1.07-1.07c13.75-12.2,22.65-24.12,30.6-41.22 c1.28-2.75,3.11-4.88,5.28-6.47c1.03-5.15,4.68-8.95,9.22-11.26c7,6.2,18.27,16.68,22.19,23.36 C510.42,245.99,531.14,294.42,499.07,320.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.451,
    y1: 276.4667,
    x2: 523.7388,
    y2: 165.0279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#57E7C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D8FF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M441.84,202.91c-21.06-2.1-41.61,0.65-56.57,15.46c-5.83,5.77-12.06,15.71-14.74,23.82 c-3.29,9.96-2.17,15.26,5.25,19.01c14.97,7.55,7.53,11.8,4.55,18.71c-1.29,2.98-1.84,6.14,0.47,8.65 c3.46,3.76,8.83,0.05,12.83,0.43c19.28,1.83,2.66,15.17,14.54,22.67c6.25,3.95,11.75-0.5,17.32-1.42 c20.21-3.35,12.53,9.46,24.2,14.73c5.33,2.41,10.38,0.65,13.95-3.44c4.76-5.44,1.03-15.14,13.84-13.38 c3.37,0.47,7.56,3.79,10.79,1.76c6.44-4.04,8.41-10.67,10.3-18.05C508.44,253.37,482.27,206.93,441.84,202.91z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M443.64,212.18c-8.22-2.15-8.72,4.81-27.05,11.28c-13.08,4.62-26.72,7.7-36.95,14.83 c-3.22,2.25-4.23,4.74,0.77,2.41c13.98-6.52,28.53-8.68,43.33-13c8.12-2.38,15.87-3.93,21.26-10.7 C446.85,214.67,444.68,212.45,443.64,212.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M458.3,230.88c-1.22,3.66-2.68,11.94-3.84,15.37c-2.97,8.75-5.46,15.39-9.88,21.86 c-6.36,9.32-14.25,16.24-20.9,25.32c-4.91,6.7-0.07,5.28,0.9,4.56c8.43-6.18,17.28-17,22.95-24.5 c5.04-6.65,17.54-24.7,18.48-40.22C466.39,227.09,460.09,225.52,458.3,230.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M465.11,286.67c0.06-1-1.01-2-2.11-1.61c-4.08,1.43-7.24,6.86-9.01,11.16c-3.33,8.08-2.1,10.32-1.04,11.24 c2.96,2.59,6.85-4.1,7.9-6.52C463.46,295.01,464.86,291.28,465.11,286.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M468.83,260.73c-0.08-0.77-1.01-1.41-1.81-0.97c-2.95,1.59-4.71,6.13-5.54,9.63 c-1.57,6.58-0.35,8.15,0.57,8.73c2.58,1.62,4.74-3.97,5.26-5.95C468.58,267.31,469.2,264.29,468.83,260.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M409.55,284.73c-0.27,0.87,0.44,1.98,1.5,1.89c3.92-0.34,7.92-4.42,10.44-7.81c4.74-6.37,4.16-8.62,3.44-9.67 c-2.03-2.94-6.95,2.08-8.43,3.97C412.89,277.76,410.81,280.73,409.55,284.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M430.8,265.68c-0.22,0.71,0.36,1.62,1.23,1.55c3.2-0.28,6.48-3.61,8.54-6.38c3.88-5.21,3.4-7.05,2.82-7.91 c-1.66-2.41-5.68,1.7-6.89,3.25C433.52,259.98,431.83,262.41,430.8,265.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M390.05,250.38c-0.54,0.63-0.34,1.83,0.59,2.13c3.43,1.11,8.25-0.9,11.59-2.86c6.27-3.68,6.59-5.78,6.35-6.93 c-0.66-3.2-6.6-0.73-8.52,0.34C395.35,245.68,392.54,247.45,390.05,250.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M428.45,244.54c-0.46,0.78-0.02,2.03,1.04,2.18c3.89,0.55,8.71-2.52,11.93-5.26c6.05-5.14,6-7.46,5.53-8.65 c-1.31-3.32-7.24,0.46-9.1,1.97C433.27,238.5,430.58,240.92,428.45,244.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M399.39,216.38c-0.66,0.33-0.9,1.38-0.25,1.95c2.43,2.08,7.07,2.09,10.47,1.63c6.4-0.86,7.38-2.48,7.58-3.49 c0.56-2.85-5.16-2.86-7.1-2.64C405.34,214.35,402.43,214.83,399.39,216.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M469.42,250.37c0.05,0.55,0.71,1,1.28,0.7c2.09-1.11,3.36-4.32,3.96-6.79c1.13-4.65,0.28-5.76-0.37-6.18 c-1.82-1.16-3.37,2.79-3.74,4.19C469.62,245.71,469.17,247.85,469.42,250.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M487.39,254.33c-1.6-4.94-7.38-9.13-10.27-4.94c-2.77,4-2.21,9.76-2.21,14.45c0,5.8-0.01,11.88-0.14,13.66 c-0.67,9.12-0.32,14-2.97,23.5c-0.83,2.98,0.08,3.78,2,1.35c1.29-1.62,3.64-7.85,4.14-10.49c1.28-6.76,3.24-12.71,4.55-19.46 C483.17,268.93,488.52,257.85,487.39,254.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M397.02,269.15c-4.44,3.85-2.37,4.09,2.24,3.3c3.89-0.66,11.55-3.85,19.72-13.16 c1.95-2.23,4.88-4.87,5.4-8.07c0.65-4.01-4.3-0.66-12.05,5.13C405.78,261.23,399.82,266.73,397.02,269.15z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.78,255.45c-2.48,0-4.79-1.23-6.17-3.28c-1.38-2.06-1.64-4.67-0.69-6.99c0.81-1.99,1.25-5.21,1.67-8.33 c0.97-7.18,1.98-14.6,7.72-17.24c1.26-0.58,3.47-2,5.81-3.51c7.68-4.95,18.21-11.73,28.09-11.73c0.55,0,1.1,0.02,1.64,0.07 c1.66,0.14,3.36,0.57,5.31,1.06c3.15,0.8,7.07,1.79,12.17,1.79c4.84,0,9.89-0.87,15.41-2.66c4.95-1.61,9.34-5.53,13.22-8.99 c2.63-2.35,4.9-4.38,7.2-5.56c3.96-2.04,8.15-3.08,12.46-3.08c3.76,0,6.91,0.77,9.23,1.44c6.04,1.74,10.84,5.64,13.18,10.69 c2.19,4.73,2.13,10.17-0.17,15.31c-6.3,14.02-33.55,24.5-53.72,24.5c-1.22,0-2.41-0.04-3.56-0.12c-1.28-0.09-2.67-0.24-4.16-0.4 c-2.59-0.28-5.53-0.6-8.51-0.6c-5.88,0-10.55,1.23-14.7,3.88c-9.34,5.95-28.48,13.06-41.01,13.74 C212.06,255.44,211.92,255.45,211.78,255.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.7971,
    y1: 276.0424,
    x2: 268.471,
    y2: 197.0157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    style: {
      stopColor: "#D8BC49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M334.14,212.75c-5.83,12.98-34.32,23.26-53.28,21.98c-7.5-0.5-19.1-3.33-29.84,3.52 c-8.63,5.5-27.02,12.45-39.04,13.11c-2.49,0.14-4.23-2.33-3.28-4.64c0.01-0.03,0.03-0.06,0.04-0.09 c2.68-6.55,1.45-20.64,7.29-23.32c5.83-2.66,21.4-15.8,33.51-14.82c5.75,0.48,15.37,6.2,34.48,0c9.2-2.98,16.11-12.26,21.03-14.81 c7.68-3.96,14.38-2.58,18.68-1.35C333.24,195.09,338.19,203.73,334.14,212.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 646.9226,
    y1: 180.1276,
    x2: 586.2425,
    y2: 124.238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#006EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0000FF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M632.69,154.44c-0.35,0.72-0.75,1.41-1.17,2.08c-7.31,11.6-24.31,15.13-39.26,7.75 c-15.8-7.79-23.33-24.83-16.82-38.05c0.77-1.59,1.73-3.05,2.83-4.36c8.01-9.75,23.7-12.33,37.61-5.48 C628.77,122.73,638.5,142.65,632.69,154.44z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M623.26,153.93c-0.25,0.51-0.53,0.99-0.82,1.46c-5.14,8.15-17.08,10.63-27.58,5.44c-11.1-5.47-16.39-17.44-11.81-26.73 c0.54-1.12,1.21-2.14,1.99-3.07c5.63-6.85,16.65-8.66,26.42-3.85C620.51,131.66,627.34,145.65,623.26,153.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 603.6724,
    y1: 115.3188,
    x2: 622.4546,
    y2: 157.8257
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F198DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6865,
    style: {
      stopColor: "#F58E7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M634.25,149.05c-1.2-10.67-8.93-22.58-18.38-27.25c-9.17-4.52-19.09-4.93-27.09-1.9 c-2.51,0.95-4.68-2.02-2.96-4.07l0.06-0.07c8.4-4.36,19.69-4.49,29.99,0.6C626.96,121.84,635.72,137.33,634.25,149.05z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M616.31,153.43c-0.19,0.27-0.4,0.53-0.61,0.77c-3.75,4.27-10.94,4.6-16.57,0.6 c-5.95-4.22-7.92-11.68-4.39-16.67c0.42-0.6,0.91-1.13,1.44-1.6c3.91-3.46,10.5-3.5,15.74,0.22 C616.78,140.2,619.46,148.99,616.31,153.43z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M613.03,151.13c-0.13,0.19-0.28,0.37-0.43,0.54c-2.62,2.99-7.65,3.22-11.59,0.42c-4.17-2.95-5.54-8.17-3.07-11.66 c0.29-0.42,0.63-0.79,1.01-1.12c2.74-2.42,7.35-2.45,11.02,0.15C613.36,141.87,615.23,148.02,613.03,151.13z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M361.45,79.58l-4.08,4.3c-4.69,4.94-5.03,10.67-5.4,16.75c-0.16,2.71-0.33,5.49-0.91,8.16 c-0.61,2.75-6.54,13.83-24.44,18.22c-13.81,3.4-21.58,15.35-26.2,24.02c-1.77,3.29-3.14,9.94-4.49,16.36 c-0.05,0.3-0.12,0.58-0.19,0.88c-1.41,6.78-2.91,13.7-5.19,19.03c-3.98,9.3-19.1,10.69-27.76,10.69c-8.12,0-16.23-1.22-20.69-3.13 c-1.52-0.65-2.91-0.97-4.26-0.97c-4.89,0-10.22,4.31-18.34,12.25c-5.48,5.36-9.87,7.84-13.81,7.84c-3.77,0-7.97-2.54-8.81-9.6 c-0.03-0.27-0.05-0.56-0.08-0.84c-0.38-4.87-12.79-21.82-17.38-24.66c-5.71-3.53-12.51-11.19-12.81-11.52l-1.02-1.16v-0.26 c1.54-0.31,2.9-0.77,4.08-1.31c1.71-0.76,3.07-1.69,4.11-2.54c3.33-2.76,6.74-5.4,10.43-7.65c1.44-0.87,2.87-1.74,4.28-2.6 l6.88-4.09l1.1-0.65c0.92-0.54,1.86-1.09,2.79-1.63l0.18,1.92c1.13,12.49,10.86,13.84,15,13.84c1.71,0,3.4-0.22,4.87-0.64 c1.73-0.48,3.43-0.72,5.17-0.72c2.31,0,4.35,0.41,6.5,0.83c2.42,0.48,4.91,0.95,8.18,0.95c2.86,0,5.89-0.35,9.3-1.11 c12.39-2.73,18.44-14.71,22.07-21.88c0.67-1.31,1.24-2.43,1.78-3.39c1.66-2.92,4.57-5.86,7.65-8.96c3.41-3.45,7.65-7.74,8.1-10.4 c0.76-4.53,3.25-10.9,10.25-18.03c3.64-1.36,7.22-2.64,10.7-3.83c0.01-0.01,0.01-0.01,0.01-0.01c17.32-5.98,32.49-10.13,45.4-12.98 C356.85,80.52,359.18,80.03,361.45,79.58z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M438.19,136.44c-1.52,3.13-5.47,4.64-12.02,4.64c-10.45,0-29.27-4.53-42.01-16.99 c-8.4-8.23-13.11-8.91-16.83-8.91c-0.71,0-1.37,0.03-2.05,0.05c-0.73,0.03-1.44,0.05-2.15,0.05c-1.22,0-2.26-0.08-3.25-0.24 c-2.77-0.46-4.72-2.3-5.22-4.91c-1.29-6.7,8.48-17.48,12.14-19.7c1.43-0.94,4.84-6.73,7.76-13.16c1.6-0.24,3.14-0.48,4.62-0.67 c5.91-0.8,10.89-1.25,14.89-1.51c0.46-0.03,0.91-0.05,1.35-0.08c0.92-0.05,1.79-0.1,2.6-0.12c-0.01,0.35-0.08,1.92,0.44,3.77 c0.35,0.8,2.12,3.3,3.55,5.33c5.85,8.32,10.73,15.69,11.27,21.56c0.27,3,6.05,8.46,11.12,12.4c4.83,3.74,9.61,7.55,12.73,11.54 C439.59,132.7,438.69,135.42,438.19,136.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.0426,
    y1: 82.6629,
    x2: 407.9107,
    y2: 147.6885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F198DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6865,
    style: {
      stopColor: "#F58E7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M386.92,121.25c-13.89-13.58-19.89-9.03-26.39-10.1c-6.5-1.1,4.16-14.82,8.32-17.35 c3.64-2.23,9.05-14.28,10.33-17.2c5.91-0.8,10.89-1.25,14.89-1.51c-0.04,0.98,0.01,2.76,0.61,4.77 c0.91,3.06,13.92,18.08,14.64,26.04c0.72,7.95,17.8,17.17,24.66,26.02C440.87,140.77,405.1,139.05,386.92,121.25z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M533.28,163.59l-0.2,0.14c-3.26,2.28-5.57,4.2-7.21,5.75l-0.24,0.24c-2.42,2.38-3.21,3.92-3.45,4.79 c-0.23,0.9-0.42,1.75-0.6,2.53c-0.69,3.19-1.86,8.52-7.87,8.52c-0.97,0-2.01-0.15-3.19-0.46c-4.05-1.05-7.31-3.58-10.78-6.25 c-2.46-1.9-4.99-3.87-8.08-5.56c-6.88-3.78-11.92-6.88-12.59-10.89c-0.01-0.07-0.01-0.15-0.03-0.22c-0.05-0.37-0.07-0.75-0.03-1.13 c0.11-1.4,0.87-3.97,4.74-5.38c1.1-0.39,2.26-0.6,3.47-0.6c2.26,0,4.26,0.69,5.85,1.25c0-0.01,0.01-0.01,0.03-0.03 c0.05-1.73-0.23-2.9-0.49-4.01c-0.48-1.9-0.77-3.74-0.05-5.81c0,0,0,0,0-0.01c0.22-0.58,0.52-1.2,0.92-1.84 c0.6-0.94,1.43-1.93,2.56-3c2.65-2.53,5.51-3.52,7.59-4.26c0.56-0.19,1.31-0.45,1.7-0.65c0-0.2-0.01-0.56-0.12-1.1 c-1.1-5.91-23.89-30.55-39.01-30.77c-3.15-0.04-9.73-0.14-9.69-5.32c0.03-3.75,3.52-5.68,13.34-7.41 c6.89-1.22,15.58-1.93,24.65-2.04c4.91,1.24,9.53,2.54,13.69,3.89c0.01,0,0.01,0,0.03,0c0.57,0.19,1.14,0.38,1.7,0.57 c4.27,1.44,7.99,2.92,11,4.46c2.43,1.25,4.65,2.38,6.68,3.41v0.01c0.73,0.37,1.45,0.73,2.13,1.09c0.68,0.34,1.32,0.67,1.94,0.99 c1.66,0.84,3.17,1.6,4.54,2.3c-0.34,0.31-0.79,0.49-1.26,0.49l-2.09,0.01c-2.5,0.01-5.94,0.83-6.61,1.84 c-0.11,0.16-0.07,0.69,0.27,1.5c0.49,1.2,0.95,2.28,1.39,3.3c2.94,6.87,4.88,11.42,3.59,18.64c-0.42,2.42-1.05,4.19-1.55,5.6 c-0.95,2.66-1.07,3,0.88,5.82C537.04,152.98,537.95,160.31,533.28,163.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.558,
    y1: 198.1541,
    x2: 498.6996,
    y2: 115.9569
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    style: {
      stopColor: "#D8BC49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7769,
    style: {
      stopColor: "#EA9D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M530.94,160.24c-1.78,1.25-6.74,4.65-9.98,8.5c-1.28,1.54-2.3,3.14-2.72,4.69c-1.48,5.48-0.99,9.2-6.72,7.72 c-5.72-1.5-10.2-7.22-17.92-11.45c-4.65-2.56-8.76-5.02-10.09-7c-0.87-1.31-0.54-2.42,1.63-3.21c5.48-1.98,11.2,5.48,11.94-1.98 c0.75-7.46-3.48-7.97,1.75-12.94c5.22-4.98,11.76-2.24,10.36-9.71c-1.4-7.46-25.55-33.84-42.96-34.1 c-16.91-0.23,5.86-8.48,43.66-6.23c4.27,1.44,7.99,2.92,11,4.46c2.43,1.25,4.65,2.38,6.68,3.41v0.01c0.73,0.37,1.45,0.73,2.13,1.09 c-3.83,0.61-9.54,2.56-6.97,8.7c3.73,8.96,5.97,12.7,4.73,19.66c-1.25,6.97-4.49,8.01,0,14.45 C531.93,152.78,533.42,158.5,530.94,160.24z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M312.21,184.34c-2.07,0-3.84-0.85-5-2.39c-2.94-3.9-1.1-10.3,3.33-25.78c0.61-2.14,1.27-4.43,1.96-6.86 c6.29-22.31,29.47-24.84,39.15-24.89h0.14c3.9,0,7.77,0.87,11.2,2.53c9.02,4.35,13.47,11.4,11.91,18.85 c-1.68,8.04-10.2,14.14-20.26,14.51c-9.41,0.34-14.98,5.45-21.42,11.36c-3.89,3.57-7.91,7.25-12.99,9.98 C316.74,183.5,314.27,184.34,312.21,184.34C312.21,184.34,312.21,184.34,312.21,184.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.1194,
    y1: 201.7948,
    x2: 324.7884,
    y2: 139.0937
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    style: {
      stopColor: "#D8BC49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M361.21,130.61c-2.97-1.43-6.24-2.14-9.54-2.12c-9.3,0.05-29.76,2.44-35.24,21.92 c-7.17,25.45-10.91,34.49,1.87,27.64c12.78-6.86,19.08-21.2,36.19-21.82C370.31,155.65,379.05,139.22,361.21,130.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 548.2508,
    y1: 142.6335,
    x2: 632.1202,
    y2: 213.4565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#57E7C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D8FF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M663.44,208.11c-0.05,0.11-0.11,0.22-0.16,0.33c-0.12,0.2-0.26,0.39-0.42,0.56c-0.56,0.58-1.39,0.87-2.6,0.57 c-4.36-1.09-10.9-4.8-10.9-4.8s-0.01,0-0.03,0.04c-0.03,0.03-0.07,0.11-0.01,0.27c0.03,0.12,0.11,0.29,0.26,0.5 c0.11,0.19,0.29,0.42,0.54,0.69c0.1,0.11,0.22,0.24,0.34,0.37c0.27,0.26,0.58,0.56,0.97,0.91h0.01c0.1,0.08,0.2,0.18,0.31,0.27 c3.06,2.61,6.1,9.16,4.58,12.21c-1.52,3.06-6.1,3.71-9.38,2.19c-3.28-1.54-8.73-5.23-11.99-3.28c-1.07,0.65-4.28,2.15-8.65,3.93 c4.13-10.44-10.97-12.34-15.53-13.61c-4.55-1.26-19.5-6.84-29.62-8.61c-10.13-1.77-19.5-7.08-20-15.19 c-0.18-2.87-1.54-5.29-3.32-7.45c-3.26-3.94-7.95-7.02-9.58-10.28c-2.47-4.99-0.34-6.05-0.03-12.11c0-0.1,0.01-0.19,0.01-0.3 c0.26-6.32-2.79-3.79-4.55-9.86c-1.78-6.05-6.84-12.67-6.84-15.96c0-3.29-0.26-4.57-1.02-10.65c-0.76-6.08,5.36-9.45,5.36-9.45 l0.16-0.03c7.95,3.96,9.98,4.69,15.62,6.82c0.76,0.29,1.69,0.58,2.72,0.91l0.01,0.01c0,0-6.93,2.75-6.21,8.89 c0.6,5.13,6.08,8.33,5.44,12.36c-1.4,8.75,6.73,9.07,7.38,17.43c0.27,3.45-0.44,7.98-4.04,6.29c-3.17-1.47-1.96-4.21-2.6-6.36 c-0.11-0.37-0.29-0.72-0.53-1.05c-1.65-2.16-3.79-3.74-4.04,1.01c0,0.15-0.01,0.31-0.01,0.48c-0.12,5.32,1.32,10.25,4.05,13.34 c2.75,3.1,5.47,3.83,6.09,7.42c0.61,3.58,6.54,3.45,5.3,0c-1.22-3.47-5.68-9.11-2.96-10.79s3.71-1.69,6.43,1.4 c2.72,3.09,5.93,5.19,10.01,5.07c4.08-0.12,10.85,0.11,14.71,5.06c4.62,5.95,13.47,7.21,15.81,7.3c7.7,0.29,8.82,7.25,16.56,8.84 c7.08,1.47,17.4,6.04,26.47,4.49c0.82,1.5,1.98,2.72,3.1,3.64c0.34,0.31,0.75,0.61,1.22,0.94 C663.56,204.05,664.3,206.26,663.44,208.11z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M572.42,198.11c-6.24-2.68-10.9-6.97-11.26-12.63c-0.18-2.87-1.54-5.29-3.32-7.45 c-3.26-3.94-7.95-7.02-9.58-10.28c-2.47-4.99-0.34-6.05-0.03-12.11c0-0.1,0.01-0.19,0.01-0.3c0.26-6.32-2.79-3.79-4.55-9.86 c-1.78-6.05-6.84-12.67-6.84-15.96c0-3.29-0.26-4.57-1.02-10.65c-0.76-6.08,5.36-9.45,5.36-9.45l0.16-0.03 c1.41,0.69,2.64,1.31,3.73,1.82c-2.96,3.06-1.36,12.46,2.78,18.94c6.2,9.69,4.78,13.86,3.46,23.6c-0.39,2.91-1.4,10.73,3.87,17.08 C558.29,174.57,572.24,185.79,572.42,198.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 535.9136,
    y1: 191.3524,
    x2: 589.1509,
    y2: 235.2329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#57E7C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D8FF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M619.61,225.46c-8.2,2.99-18.19,6-26.31,6.8c0,0-0.23-2.37,0.72-4c0.97-1.65-3-4.92-5.33-1.65 c-2.32,3.28-10.21,9-13.26,7.25c-1.58-0.91-13.38-6.84-17.21-8.17c-3.82-1.33-2.73-2.22-2.46-5.63c0.27-3.41,2.6-8.2-2.46-7.93 c-5.06,0.27-1.9,5.6-5.33,10.74c-3.41,5.15-7.78,1.69-16.94,1.55c-9.15-0.14-13.12-4.5-14.62-9.45c-1.51-4.95,9.6-0.98,13.8-3.25 c4.01-2.18,7.98-6.1,21.05-7.93c4.68-0.65,6.96-4.65,6.01-7.65c-0.97-3,2.92-1.09,4.58,0.18c3.74,2.87,4.12,5.42,12.83,7.22 c8.71,1.79,25.4,8.39,30.32,9.42C614.05,214.88,624.85,216.01,619.61,225.46z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M538.8,180.88c-0.3-0.02-3.44,0-3.33,3.03s7.78,4.75,8.99,3.03C545.67,185.22,544.16,181.18,538.8,180.88z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M530.31,174.61c0.3-0.02,3.44,0,3.33,3.03c-0.1,3.03-7.78,4.75-8.99,3.03 C523.44,178.95,524.95,174.91,530.31,174.61z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M493.11,190.53c0.12,0.22,1.45,2.38,3.5,1.03s0-7.38-1.7-7.5C493.22,183.94,491.06,186.69,493.11,190.53z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M506.93,198.39c0.26,0.12,3.07,1.19,4.08-1.66s-5.22-7.13-6.93-5.95 C502.37,191.95,502.26,196.24,506.93,198.39z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M544.55,199.13c-0.27,0.01-3.09,0-3-2.65c0.09-2.65,6.99-4.16,8.08-2.65 C550.73,195.32,549.36,198.86,544.55,199.13z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M524.59,191.45c0.25,0,2.78-0.14,2.62-1.75c-0.16-1.62-6.42-2.23-7.35-1.27 C518.92,189.39,520.25,191.5,524.59,191.45z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M514.25,206.08c0.26,0,2.91-0.14,2.75-1.84c-0.17-1.7-6.73-2.34-7.71-1.33S509.69,206.13,514.25,206.08z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M536.92,201.55c-0.89,3.54-7.59,4.53-10.73-0.52c-0.13-0.2-0.91-1.74,0.13-3.39 c0.98-1.57,2.99-2.15,4.75-1.58c1.33,0.44,2.5,1.11,3.05,2.16c0.22,0.42,0.46,0.8,0.73,1.14 C535.83,200.71,537.36,199.84,536.92,201.55z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M542.48,167.07c-0.23-0.21-2.73-2.2-4.92,0.69c-2.19,2.88,2.61,9.4,4.86,8.57 C544.67,175.51,546.5,170.78,542.48,167.07z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M165.75,203.77c0.3-0.08,3.33-1.08,2.12-4.49s-9.29-2.97-9.83-0.63C157.49,200.97,160.44,205.1,165.75,203.77z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.2846,
    y1: 174.92,
    x2: 140.2846,
    y2: 168.064
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M143.44,169.07c-6.42,1.73-9.87-1.31-9.78-3.74c4.47-0.31,9.01-0.48,13.21-0.33 C147.28,167.83,143.8,168.97,143.44,169.07z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M171.67,218.62c0.33-0.08,3.69-1.19,2.35-4.97c-1.34-3.78-10.28-3.28-10.88-0.7 C162.53,215.54,165.8,220.1,171.67,218.62z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M182.25,227.99c0.18-0.19,1.94-2.26-0.45-4.2c-2.39-1.94-8.05,1.96-7.41,3.9S178.99,231.31,182.25,227.99z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M554.63,182.78c-0.15-0.14-1.79-1.44-3.23,0.45c-1.44,1.89,1.71,6.17,3.19,5.63S557.27,185.21,554.63,182.78z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M493.92,235.3c-0.94,1.05-1.9,1.9-2.87,2.58c-10.14-18.63-27.64-32.83-49.2-34.98c-6.32-0.63-12.6-0.82-18.69-0.38 c-0.41-1.52-0.68-3.28-0.82-5.32c-0.03-0.39-0.04-0.79-0.04-1.18c0-3.73,1.25-6.74,3.14-9.16c4.27-5.42,11.83-7.79,15.93-8.31 c26.51-3.37,35.43,8.91,38.87,13.02c9.87,11.79,15.63,12.48,23.82,17.42C512.24,213.93,505.42,222.47,493.92,235.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M488.22,143.82c0,0.01-0.01,0.03-0.01,0.03c-0.24,0.65-0.54,1.25-0.91,1.81c0.01,0,0,0.01,0,0.01 c-0.23,0.41-0.52,0.79-0.82,1.14c-1.33,1.59-3.82,3.48-8.14,3.48c-2.79,0-6.05-0.8-9.71-2.38c-1.07-0.46-2.03-0.69-2.81-0.69 c-3.56,0-4.69,6.54-4.79,9.99l-0.08,3.13l0,0c-0.06,2.11-2.52,3.23-4.15,1.9l-2.43-1.98c-0.19-0.16-0.39-0.33-0.58-0.5 c-11.15-9.49-14.98-24.7-8.33-33.54c0.19-0.24,0.31-0.44,0.38-0.57c-0.75-0.86-3.24-2.31-5.1-3.4c-3.37-1.96-7.57-4.4-11.2-8.03 c-9.27-9.27-18.99-35.84-19.4-36.97l-0.72-1.97c9.07,1.13,35.5,4.57,61.21,9.57v0c0,1.79-1.43,3.25-3.22,3.29l-0.78,0.02 c-23.14,0.48-26.93,3.25-27.54,4.17c-0.08,1.4,0.15,2.04,4.65,3.06c2.38,0.53,5.34,1.21,6.24,4.23c0.58,1.94-0.04,3.89-1.86,5.78 c-0.52,0.53-0.67,0.87-0.67,0.95c0,0.03,0.16,1.13,3.89,3.37c2.32,1.4,6.36,2.75,10.65,4.17c11.01,3.7,24.73,8.29,26.67,19.41 C489.39,137.62,489.25,141.1,488.22,143.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.8796,
    y1: 172.35,
    x2: 449.7766,
    y2: 107.5406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0695,
    style: {
      stopColor: "#BAF07C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    style: {
      stopColor: "#D8BC49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7769,
    style: {
      stopColor: "#EA9D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M470.25,144.17c-9.73-4.2-13.08,5.23-13.3,12.93c-9.64-7.87-13.68-21.21-8.24-28.43 c5.42-7.21-7.56-8.61-16.3-17.35c-8.74-8.74-18.45-35.47-18.45-35.47s0,0,0.01,0c10.89,1.4,31.65,4.28,52.55,8.2 c0.01,0,0.01,0.01,0.01,0.01c-15.99,0.33-31.13,1.71-31.53,7.91c-0.63,9.83,14.97,5.59,10.16,10.56 c-4.81,4.98,1.14,8.91,4.07,10.66c8.8,5.29,33.19,8.18,35.39,20.8C486.83,146.61,479.98,148.37,470.25,144.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 543.7598,
    y1: 211.5936,
    x2: 543.3761,
    y2: 250.347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#57E7C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D8FF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M572.17,242.12c-9.42,3.87-24.16,6.28-53,1.24c-1.43-2.24-2.58-4.36-3.34-6.77 c-1.51-4.74-2.15-7.25,4.53-6.93c6.69,0.33,15.28,4.7,19.41,3.11C543.7,231.25,556.94,226.66,572.17,242.12z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M438.39,164.97c-5.38,9.75-3.18,12.67-2.58,14.96c-3.64,1.29-7.67,3.49-10.37,6.93 c-1.89,2.42-3.14,5.44-3.14,9.16c-0.63,0.12-1.35,0.18-2.18,0.16c-13.55-0.24-23.91-13.05-19.54-19.07 c8.18-11.26,5.55-11.79,1.5-16.1c-4.68-4.99,2.04-14.23,15.65-9.39c2.68,0.95,4.83,0.29,6.17-1.37c2.81-3.44,7.72-5.67,11.75-3.79 C441.72,149.3,441.64,159.09,438.39,164.97z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4107 -0.9117 0.9117 0.4107 235.5402 635.751)",
    className: "st30",
    cx: 609.62,
    cy: 135.65,
    rx: 1.59,
    ry: 2.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4107 -0.9117 0.9117 0.4107 217.3863 644.4746)",
    className: "st30",
    cx: 607.29,
    cy: 154.06,
    rx: 0.95,
    ry: 1.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.5173,
    y1: 7.6667,
    x2: 237.0768,
    y2: 179.0721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    style: {
      stopColor: "#D8BC49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7769,
    style: {
      stopColor: "#EA9D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M357.34,80.41h0.07c-11.2,6.69-8.58,19.46-10.35,27.5c-0.33,1.47-5.17,11.13-21.44,15.13 c-16.29,4.01-24.81,18.54-28.82,26.06c-4.01,7.52-5.51,26.06-10.02,36.59s-34.07,9.26-43.1,5.41c-9.01-3.85-15.78,1.1-27.06,12.13 c-11.27,11.01-15.28,6.51-15.78,0c-0.5-6.53-14.03-24.55-19.29-27.82c-5.26-3.26-11.9-10.75-11.9-10.75v-0.01 c1.71-0.76,3.07-1.69,4.11-2.54c3.33-2.76,6.74-5.4,10.43-7.65c1.44-0.87,2.87-1.74,4.28-2.6l6.88-4.09 c1.52,16.89,16.63,19.14,25.04,16.76c8.42-2.37,12.3,3.67,28.92,0c16.63-3.67,23.03-21.17,26.5-27.22 c3.45-6.05,14.79-14.15,16.25-20.71c2.61-11.8,12.2-20.88,12.2-20.88c6.5-9.16,18.87-14.15,25.19-16.71 c1.33-0.54,2.39-0.97,3.19-1.35c6.65-3.17,12-14.74,12-22.2c0-2.96,0.42-3.81,0.42-3.87c0.05-0.03,0.33-0.15,1.21-0.24 c2.18-0.24,3.89-1.43,4.7-3.25c0.45-1.01,0.54-2.05,0.44-3.06c1.05,0.57,2.11,1.14,3.18,1.73l0.23,2.43 c-2.13,0.46-3.93,1.77-4.94,3.7c-1.44,2.76-1.05,6.23,1.09,9.5c0.9,1.37,2.03,2.49,3.05,3.4c-1.25,0.76-2.77,2.07-3.13,4.19 c-0.49,3.03,1.66,4.99,3.37,6.55c1.26,1.17,2.58,2.38,3.14,3.86C357.38,80.4,357.36,80.41,357.34,80.41z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M347.41,232.41c-0.31,8.78-3.81,15.42-8.43,21.52c-0.64-0.35-1.14-0.75-1.52-1.17 c-1.74-1.97-15.51,5.11-21.63,14.17c-0.24,0.35-0.69,0.84-1.36,1.43c-9.24,8.35-57.67,38.64-84.97,37.02 c-25.71-1.51-51.43,14.49-53.57-12.47c-0.12-1.47-0.16-3.06-0.14-4.8c0.05-2.54-3.18-3.63-4.66-1.58 c-2.54,3.55-5.81,8.08-9.35,12.97c-5.08-13.66-3.1-24.61,3.13-29.56c0,0,12.11-10.67,29.5-21.86c0.73-0.46,1.47-0.94,2.22-1.4 c0.53-0.34,1.06-0.67,1.6-1.01c0.75-0.46,1.51-0.92,2.27-1.39c0.88-0.54,1.78-1.07,2.69-1.6l0.49-0.29 c2.09-1.22,4.24-2.43,6.43-3.62c5.66-3.05,11.58-5.9,17.63-8.33c0.6-0.24,1.2-0.48,1.79-0.71s1.21-0.46,1.81-0.68 c0.53-0.2,1.06-0.39,1.59-0.58c0.8-0.29,1.6-0.56,2.41-0.83c1.09-0.35,2.18-0.71,3.28-1.03c2.99-0.91,6-1.67,9-2.27 c0.64-0.14,1.26-0.26,1.9-0.37C290.17,216.75,348.51,201.51,347.41,232.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.4019,
    y1: 237.8819,
    x2: 252.4225,
    y2: 298.1374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#151613"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    style: {
      stopColor: "#0C1883",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#048762",
      stopOpacity: 0
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M347.41,232.41c-0.31,8.78-3.81,15.42-8.43,21.52c-0.64-0.35-1.14-0.75-1.52-1.17 c-1.74-1.97-15.51,5.11-21.63,14.17c-0.24,0.35-0.69,0.84-1.36,1.43c-19.67,2.54-39.89,0.01-55.18,1.59 c-20.22,2.08-53.82-15.91-64.88-21.86c0.73-0.46,1.47-0.94,2.22-1.4c0.53-0.34,1.06-0.67,1.6-1.01c0.75-0.46,1.51-0.92,2.27-1.39 c0.88-0.54,1.78-1.07,2.69-1.6l0.49-0.29c2.09-1.22,4.24-2.43,6.43-3.62c5.66-3.05,11.58-5.9,17.63-8.33 c0.6-0.24,1.2-0.48,1.79-0.71s1.21-0.46,1.81-0.68c0.53-0.2,1.06-0.39,1.59-0.58c0.8-0.29,1.6-0.56,2.41-0.83 c1.09-0.35,2.18-0.71,3.28-1.03c2.99-0.91,6-1.67,9-2.27c0.64-0.14,1.26-0.26,1.9-0.37C290.17,216.75,348.51,201.51,347.41,232.41z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.8408,
    y1: 267.09,
    x2: 278.5031,
    y2: 267.09
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2254,
    style: {
      stopColor: "#D5C24F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M270.75,247.01c1.48-1.48,7.31-7.05,7.75-3.21c0.44,3.84-34.78,38.17-45.85,45.93s4.38-8.95,16.36-20.82 C264.03,254,265.3,252.47,270.75,247.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.5265,
    y1: 261.5608,
    x2: 303.1888,
    y2: 261.5608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2254,
    style: {
      stopColor: "#D5C24F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M295.43,241.48c1.48-1.48,7.31-7.05,7.75-3.21c0.44,3.84-34.78,38.17-45.85,45.93 c-11.08,7.75,4.38-8.95,16.36-20.82C288.72,248.47,289.98,246.94,295.43,241.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.2122,
    y1: 255.756,
    x2: 327.8745,
    y2: 255.756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2254,
    style: {
      stopColor: "#D5C24F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M320.12,235.67c1.48-1.48,7.31-7.05,7.75-3.21c0.44,3.84-34.78,38.17-45.85,45.93 c-11.08,7.75,4.38-8.95,16.36-20.82C313.41,242.67,314.67,241.13,320.12,235.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.1551,
    y1: 272.0276,
    x2: 253.8173,
    y2: 272.0276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2254,
    style: {
      stopColor: "#D5C24F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M246.06,251.94c1.48-1.48,7.31-7.05,7.75-3.21c0.44,3.84-34.78,38.17-45.85,45.93 c-11.08,7.75,4.38-8.95,16.36-20.82C239.35,258.94,240.61,257.41,246.06,251.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.0161,
    y1: 270.1123,
    x2: 231.0722,
    y2: 270.1123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5F883"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2254,
    style: {
      stopColor: "#D5C24F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98311"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M224.03,251.89c1.34-1.35,6.63-6.39,7.03-2.91s-31.55,34.63-41.6,41.67c-10.05,7.03,3.97-8.12,14.84-18.89 C217.95,258.24,219.09,256.85,224.03,251.89z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M109.36,223.48c7.77-1.22,15.55-2.37,23.34-3.43c3.9-0.53,7.8-1.03,11.71-1.49 c3.91-0.45,7.83-0.88,11.78-1.17c0.6-0.05,1.13,0.41,1.18,1.01c0.05,0.6-0.41,1.13-1.01,1.18c-0.01,0-0.02,0-0.03,0 c-3.9,0.19-7.81,0.52-11.71,0.87c-3.91,0.35-7.81,0.76-11.71,1.19c-7.81,0.86-15.61,1.81-23.39,2.83 c-0.27,0.04-0.53-0.15-0.56-0.43C108.91,223.78,109.09,223.53,109.36,223.48z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M106.9,243.25c7.42-2.6,14.87-5.13,22.34-7.58c3.74-1.22,7.49-2.42,11.25-3.57 c3.77-1.15,7.54-2.28,11.37-3.28c0.59-0.15,1.19,0.2,1.34,0.78s-0.2,1.19-0.78,1.34c-0.01,0-0.02,0.01-0.03,0.01 c-3.8,0.89-7.59,1.92-11.36,2.97c-3.78,1.05-7.55,2.16-11.31,3.28c-7.52,2.25-15.02,4.59-22.5,7c-0.26,0.09-0.54-0.06-0.63-0.32 C106.51,243.61,106.65,243.34,106.9,243.25z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M101.52,207.07c7.83-0.75,15.66-1.43,23.51-2.01c3.92-0.29,7.85-0.56,11.78-0.78 c3.93-0.22,7.87-0.41,11.82-0.46c0.61-0.01,1.1,0.48,1.11,1.08s-0.48,1.1-1.08,1.11c-0.01,0-0.02,0-0.03,0 c-3.9-0.04-7.82,0.05-11.74,0.16c-3.92,0.12-7.84,0.29-11.76,0.48c-7.84,0.38-15.69,0.86-23.52,1.41 c-0.28,0.02-0.52-0.19-0.54-0.46C101.05,207.34,101.25,207.1,101.52,207.07z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M120.59,262.27c6.2-3.88,12.42-7.7,18.7-11.45c3.14-1.87,6.29-3.73,9.47-5.55c3.18-1.81,6.37-3.61,9.64-5.3 c0.54-0.28,1.2-0.07,1.48,0.47c0.28,0.54,0.07,1.2-0.47,1.48c-0.01,0-0.02,0.01-0.03,0.01c-3.26,1.58-6.49,3.28-9.7,5 c-3.21,1.72-6.4,3.49-9.59,5.27c-6.36,3.57-12.69,7.21-18.98,10.92c-0.24,0.14-0.54,0.06-0.69-0.17 C120.29,262.71,120.36,262.41,120.59,262.27z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.9028,
    y1: 116.4985,
    x2: 275.9685,
    y2: 58.8948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#151613"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2565,
    style: {
      stopColor: "#0C533D",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#048762",
      stopOpacity: 0
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M380.6,60.93c-0.37-0.2-0.73-0.39-1.1-0.6c-2.95-1.6-6.02-3.29-9.15-4.99l-3.14-1.71 c-1.05-0.58-2.11-1.16-3.15-1.73l-5.11-2.77c-1.45-0.8-2.9-1.59-4.32-2.37c-1.07-0.58-2.13-1.16-3.18-1.73 c-1.9-1.03-3.77-2.05-5.59-3.03l-0.56-0.31c-3.32-1.81-6.46-3.52-9.33-5.07c-1.81-0.98-3.51-1.9-5.07-2.75c0,0,0,0-0.01,0 c-1.35-0.73-2.6-1.4-3.71-2c-3.4-1.84-5.7-3.07-6.42-3.43c-5-2.5-12.98-3.51-21.48-4c-8.48-0.5-30.24,2.49-38.72,8.99 c-8.5,6.49-36.18,21.47-43.17,23.97c-6.99,2.49-24.47,14.98-29.96,29.95c-5.49,14.98-14.6,29.83-15.76,31.61 c-1.71,2.61-5.89,9.46-1.7,13.81c4.2,4.34,4.2,5.28,3.73,9.78c-0.46,4.5,9.37,8.36,14.81,9.3l6.88-4.09l1.1-0.65 c0.92-0.54,1.86-1.09,2.79-1.63c1.84-1.07,3.66-2.12,5.47-3.15h0.01c0.29-0.16,0.57-0.33,0.86-0.49c0.98-0.57,1.94-1.13,2.92-1.67 c7.4-4.16,14.6-8.06,21.62-11.72l28.09-13.81c0.07-0.03,0.12-0.05,0.18-0.08c7.16-3.3,14.08-6.34,20.76-9.12 c0.08-0.03,0.16-0.05,0.26-0.1c0.14-0.05,0.26-0.11,0.39-0.16h0.01c1.07-0.45,2.13-0.88,3.18-1.31c0.65-0.27,1.29-0.53,1.93-0.79 c0.31-0.12,0.63-0.26,0.94-0.37l0.33-0.14c0.11-0.05,0.22-0.1,0.33-0.12l11.24-4.35c0.18-0.07,0.35-0.14,0.53-0.2 c0.29-0.11,0.57-0.2,0.84-0.31c0.73-0.27,1.47-0.54,2.2-0.8c0.18-0.07,0.34-0.12,0.52-0.19c0.48-0.18,0.95-0.35,1.44-0.52 c0.33-0.12,0.64-0.24,0.95-0.34l0.01-0.01c1.59-0.57,3.17-1.13,4.73-1.66c0.01-0.01,0.01-0.01,0.01-0.01 c1.36-0.48,2.71-0.92,4.04-1.37c0.95-0.31,1.9-0.64,2.84-0.94c7.84-2.58,15.2-4.77,22.07-6.62c0.72-0.19,1.43-0.38,2.13-0.57 c1.43-0.38,2.83-0.73,4.21-1.09c1.75-0.45,3.47-0.86,5.15-1.26c0.23-0.05,0.46-0.11,0.68-0.15c0.61-0.15,1.22-0.29,1.82-0.42 c0.83-0.19,1.65-0.38,2.45-0.56c0.61-0.14,1.21-0.27,1.81-0.39c0.39-0.1,0.8-0.18,1.2-0.26h-0.05c0.03,0,0.04-0.01,0.07-0.01 c0.19-0.04,0.37-0.08,0.56-0.11c0.6-0.12,1.17-0.24,1.75-0.37c0.44-0.1,0.86-0.18,1.28-0.26c0.15-0.04,0.29-0.07,0.44-0.1v0.01 l13.11-2.31c0,0,0,0,0-0.01c0.8-0.12,1.58-0.23,2.35-0.34c0.69-0.11,1.36-0.19,2.03-0.29c0.08,0,0.16-0.01,0.24-0.03 c0.37-0.04,0.73-0.1,1.1-0.15c0.12-0.03,0.23-0.04,0.35-0.05h0.01c0.23-0.03,0.48-0.05,0.71-0.08c0.71-0.1,1.4-0.18,2.08-0.26 c0.68-0.07,1.35-0.15,2-0.22s1.29-0.14,1.92-0.2c1.24-0.12,2.42-0.23,3.53-0.31c0.11-0.01,0.23-0.01,0.34-0.03 c0.87-0.07,1.7-0.12,2.49-0.18c0.12-0.01,0.23-0.01,0.35-0.03c0.46-0.03,0.91-0.05,1.35-0.08c0.92-0.05,1.79-0.1,2.6-0.12 c0.35-0.01,0.71-0.03,1.03-0.04c0.71-0.01,1.37-0.03,1.97-0.04c3.39-0.05,5.11,0.07,5.11,0.07S394.91,68.75,380.6,60.93z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215,189.12c0.35-0.09,3.87-1.25,2.47-5.22s-10.8-3.45-11.43-0.74C205.4,185.88,208.83,190.67,215,189.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.1547,
    y1: 124.2958,
    x2: 329.3554,
    y2: 111.0468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M333.24,108.17c0.27-0.25,2.97-2.97,0.7-5.06s-10.13,3.31-9.94,5.59 C324.19,110.99,328.4,112.58,333.24,108.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 562.3883,
    y1: 593.3874,
    x2: 562.5891,
    y2: 580.1384,
    gradientTransform: "matrix(0.768 -0.6405 -0.6405 -0.768 325.0092 897.0068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M390.31,90.87c0.37,0.02,4.18,0.38,3.78,3.43c-0.4,3.06-9.9,3.94-11.22,2.07 C381.56,94.5,383.77,90.58,390.31,90.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.0505,
    y1: -29.0436,
    x2: 370.2014,
    y2: -39.0045,
    gradientTransform: "matrix(0.9405 -0.3399 0.3399 0.9405 -24.6566 287.7247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M312.25,122.18c0.13-0.25,1.34-2.86-0.8-3.75c-2.14-0.9-6.32,4.93-5.6,6.49 C306.57,126.48,309.96,126.53,312.25,122.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.4776,
    y1: 124.0886,
    x2: 315.6783,
    y2: 110.8395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4948,
    style: {
      stopColor: "#1586F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A34F1"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M314.62,111.11c-0.16-0.01-1.85-0.28-1.51-2.19c0.34-1.91,4.64-2.37,5.13-1.19 C318.74,108.92,317.54,111.35,314.62,111.11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishResult6);
export default __webpack_public_path__ + "static/media/fish-result-6.c9e3d534193c6dcf9d36fa5d8de00528.svg";
export { ForwardRef as ReactComponent };